import Repository from "../../repository";

export default {
    GetMapNow_ByDataCode: (payload) => Repository.post(`/api/Maps/GetMapNow_ByDataCode`, payload),
    GetMapNowByDataCodeByStationID: (payload) => Repository.post(`/api/Maps/GetMapNow_ByDataCode_ByStationID`, payload),
    GetFilterByDataCode: (payload) => Repository.post(`/api/Maps/GetFilter_ByDataCode`, payload),
    GetMapNowCustomer: (payload) => Repository.post(`/api/TreeCustomers/GetMapNow_Customer`, payload),
}
